export default "__VITE_ASSET__Duoh_bdi__"